export const supportContent = {
  hero: {
    title: "Support That Actually Helps",
    subtitle: "No Bots. No Call Centers. Just Real Help.",
    description: "When your digital displays go down, you don't need an AI chatbot or a ticket queue. You need a real human who understands digital signage and can solve your problem fast."
  },
  promise: {
    title: "Our Support Promise",
    subtitle: "Fast, helpful support is included in every plan",
    cards: [
      {
        iconName: "AccessTime",
        title: "4-Hour Response Time",
        description: "We respond to every support email within 4 business hours. Usually much faster. If you email us at 10am on a Tuesday, you'll hear back by 2pm—guaranteed.",
        footer: "Business Hours: Monday-Friday, 9am-5pm ET"
      },
      {
        iconName: "Person",
        title: "Talk to the Founder",
        description: "During our alpha and beta phases, every support request goes directly to the founder. No middlemen, no escalations, no \"let me check with the team.\" Just direct access to the person who built BrandCast."
      },
      {
        iconName: "MultipleChannels",
        title: "Multiple Support Channels",
        description: "Email, phone, screen sharing—whatever works best for your situation. We'll hop on a Zoom call to troubleshoot together if needed."
      }
    ]
  },
  scope: {
    title: "What We Support",
    included: {
      title: "Included in Every Plan",
      items: [
        "Account setup and onboarding",
        "Content upload and scheduling",
        "Display configuration",
        "BYOD hardware compatibility questions",
        "Troubleshooting and bug reports",
        "Feature requests and feedback",
        "Billing and account management"
      ]
    },
    excluded: {
      title: "What We Don't Support",
      items: [
        "Hardware assembly (we can point you to guides)",
        "Network/WiFi configuration (that's your IT team)",
        "TV/monitor troubleshooting (not our hardware)",
        "Graphic design or content creation services"
      ],
      footer: {
        text: "For hardware assembly, check out our ",
        linkText: "BYOD Setup Guides",
        linkUrl: "https://help.brandcast.app/docs/hardware"
      }
    }
  },
  philosophy: {
    title: "Our Support Philosophy",
    whyHumanFirst: {
      title: "Why Human-First?",
      paragraphs: [
        "We've all been stuck in chatbot loops. We've all waited days for email responses from offshore support teams. We've all felt the frustration of explaining the same problem three times to different people.",
        "BrandCast is different."
      ],
      points: [
        { strong: "We're small enough to care.", text: " Every customer matters. Every issue gets personal attention." },
        { strong: "We're technical enough to help.", text: " We're not reading from scripts. We understand Raspberry Pi, BYOD setups, HDMI issues, and network quirks." },
        { strong: "We're US-based.", text: " Same timezone, same business hours, same language. When you email us at 2pm, we respond by 5pm—not tomorrow morning." }
      ]
    },
    asWeGrow: {
      title: "As We Grow",
      text: "As BrandCast grows, we'll stay committed to fast, helpful, human support. We might add AI tools to handle routine questions (password resets, basic FAQs), but you'll always have a clear path to a real human when you need one."
    }
  },
  help: {
    title: "Get Help Now",
    channels: [
      { iconName: "Email", title: "Email", linkText: "support@brandcast.app", linkUrl: "mailto:support@brandcast.app" },
      { iconName: "Help", title: "Documentation", linkText: "help.brandcast.app", linkUrl: "https://help.brandcast.app" },
      { iconName: "ScreenShare", title: "Schedule a Call", subtext: "Email us to schedule" }
    ],
    faq: {
      title: "Common Questions",
      items: [
        {
          question: "Q: Do you offer 24/7 support?",
          answer: "Not yet. We're a bootstrap startup, so support is available during US business hours (9am-5pm ET, Monday-Friday). As we grow and add team members, we'll expand to evenings and weekends."
        },
        {
          question: "Q: What if I have an emergency after hours?",
          answer: "Email support@brandcast.app with \"URGENT\" in the subject line. We monitor email outside business hours for critical issues. We'll do our best to respond quickly, but we can't guarantee same response time as business hours."
        },
        {
          question: "Q: Do you charge extra for support?",
          answer: "No. All support is included in your subscription. No tiers, no extra fees, no \"premium support\" upsells."
        },
        {
          question: "Q: What's your average response time?",
          answer: "During alpha/beta, our average response time is 2-3 hours. We guarantee 4 hours, but we're usually faster."
        }
      ]
    },
    cta: "Contact Support"
  }
};
